// src/components/dashboard/RecentActivity.tsx
import React from 'react';
import { motion } from 'framer-motion';
import { formatDistanceToNow } from 'date-fns';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Avatar, AvatarImage, AvatarFallback } from '@/components/ui/avatar';
import { TestingEntry } from '@/types';
import { Activity } from 'lucide-react';

interface RecentActivityProps {
  activities: TestingEntry[];
}

export const RecentActivity: React.FC<RecentActivityProps> = ({ activities }) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <Activity className="w-5 h-5" />
          Recent Activity
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-4">
          {activities.length === 0 ? (
            <p className="text-muted-foreground text-center py-8">No recent activity</p>
          ) : (
            activities.map((activity, index) => (
              <motion.div
                key={activity.id}
                initial={{ x: -20, opacity: 0 }}
                animate={{ x: 0, opacity: 1 }}
                transition={{ delay: index * 0.05 }}
                className="flex items-center gap-4 p-3 rounded-lg bg-muted/50 hover:bg-muted transition-colors"
              >
                <Avatar>
                  <AvatarImage src={activity.userPhoto} alt={activity.userName} />
                  <AvatarFallback>{activity.userName.charAt(0)}</AvatarFallback>
                </Avatar>
                <div className="flex-1 min-w-0">
                  <p className="text-sm font-medium truncate">{activity.userName}</p>
                  <p className="text-xs text-muted-foreground">
                    Completed testing {formatDistanceToNow(activity.timestamp, { addSuffix: true })}
                  </p>
                </div>
                <div className="text-2xl">✅</div>
              </motion.div>
            ))
          )}
        </div>
      </CardContent>
    </Card>
  );
};

